import { SerializedData } from 'bernie-core';
import { AnalyticsStore } from 'bernie-plugin-mobx';
import { RequestOptions } from 'bernie-graphql';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import analyticsWrapper from 'utility/analytics-wrapper';
import {
  FlightsShoppingPwaFlightInformationResults,
  FlightsShoppingPwaFlightInformationResultsLoading
} from '__generated__/api/';
import { BaseBexApiStore } from './bex-api-store';

export class InformationResultStore extends BaseBexApiStore {
  public hydrate(data: SerializedData): void {
    super.hydrate(data);

    this.bexApiSource.clientConfigs.bexApiUrl = '/graphql';
  }

  private addClientInfoHeader(headers, appName, region) {
    return {
      ...headers,
      'Client-Info': `${appName},latest,${region || 'external'}`
    };
  }

  public fetchLoading(
    detailsVariables: FlightsShoppingPwaFlightInformationResultsLoading.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightInformationResultsLoading.FlightsDetail> {
    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = this.addClientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsShoppingPwaFlightInformationResultsLoading(detailsVariables, options)
      .then(response => {
        this.logger.logEvent(
          new SystemEvent(SystemEventLevel.INFO, 'FIS_FETCH_LOADING_VARIABLES'),
          JSON.stringify(detailsVariables)
        );
        this.logger.logEvent(
          new SystemEvent(SystemEventLevel.INFO, 'FIS_FETCH_LOADING_RESPONSE'),
          JSON.stringify(response)
        );
        const { flightsDetail } = response.data;

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return {
          ...flightsDetail
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.CRITICAL, 'FIS_FETCH_LOADING'), error);

        return null;
      });
  }

  public fetchResults(
    detailsVariables: FlightsShoppingPwaFlightInformationResults.Variables,
    options: RequestOptions,
    analytics: AnalyticsStore
  ): Promise<FlightsShoppingPwaFlightInformationResults.FlightsDetail> {
    const { appName, region } = this.bexApiSource.clientConfigs;
    this.bexApiSource.headers = this.addClientInfoHeader(this.bexApiSource.headers, appName, region);

    return this.bexApiSource.operations
      .flightsShoppingPwaFlightInformationResults(detailsVariables, options)
      .then(response => {
        const { flightsDetail } = response?.data || {};

        analyticsWrapper.publishAnalyticsPayload(response, analytics);

        return {
          ...flightsDetail
        };
      })
      .catch(error => {
        this.logger.logEvent(new SystemEvent(SystemEventLevel.CRITICAL, 'FIS_FETCH_LOADED'), error);

        return null;
      });
  }
}
